import { BaSeHeading6, BaSeParagraph, BaSeTheme } from '@base/react';
import React from 'react';

// import { Container } from './styles';

function ModalDesist({ name, isRealize }) {
  return (
    <div>
      <BaSeHeading6
        color={BaSeTheme.colors.feedbackInterface.atencao55}
        isBold={true}
      >
        Atenção!
      </BaSeHeading6>

      <div style={{ marginTop: 8 }}>
        {isRealize ? (
          <BaSeParagraph>
            Tem certeza que deseja alterar o status da entrevista do candidato{' '}
            <strong>{name}</strong> para <strong>Desistente</strong>?
          </BaSeParagraph>
        ) : (
          <BaSeParagraph>
            Tem certeza que deseja desfazer a desistência da entrevista do{' '}
            candidato <strong>{name}</strong>?
          </BaSeParagraph>
        )}
      </div>
    </div>
  );
}

export default ModalDesist;
